import React from 'react';
import {observer} from 'mobx-react-lite';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {CategoryCard} from '../CategoryCard';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {Grid} from '@material-ui/core';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {TextBox} from '../../../Core/UI';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type DUIProps = {
    parameters: Approval;
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    index: number;
};

const DUI = observer(({parameters, valueChanged, setCategory, index}: DUIProps) => {
    return (
        <CategoryCard title={'DUI'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        inputVariant="outlined"
                        variant="inline"
                        openTo="year"
                        views={['year', 'month']}
                        label={'When did the DUI occur?'}
                        style={{width: '100%', marginTop: 8}}
                        value={parameters.DUIDate?.value || null}
                        onChange={(date) => valueChanged(parameters.DUIDate, date)}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'When did the DUI occur ? (Deprecated)',
                        name: 'duiDate',
                        options: fieldOptions.duiDate.options,
                        ...parameters.duiDate,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id="duiNotes"
                    label="Notes"
                    value={parameters.duiNotes?.value}
                    onChange={(value) => valueChanged(parameters.duiNotes, value)}
                />
            </Grid>
        </CategoryCard>
    );
});

export default DUI;
